import { convertExcelDate } from '../../../../bereiche/zusatztools/routinen/importUtil';
import { ExcelTool } from '../../../../core/excel/excel_tool';

export class ImportErzeugungsLastdaten {
    // Struktur (vorher)
    // public constructor(dataLoaded: any, startRow: number = 9, data?: any) {
    public constructor(dataLoaded: any, startRow: number = 2, data?: any) {
        this.data = data;
        this.getSheetData(dataLoaded, (startRow - 1));
    }

    private data: any;
    private dataInsert: any[] = [];
    private dataUpdate: any[] = [];
    private dataUptodate: any[] = [];
    private vergleiche: string[] = [
        'zeit',
        'sued0', 'sued15', 'sued30', 'sued45', 'sued90',
        'ost0', 'ost15', 'ost30', 'ost45', 'ost90',
        'west0', 'west15', 'west30', 'west45', 'west90',
        'ost_west15', 'ost_west30', 'ost_west45',
        'g0', 'g1', 'g2', 'g3', 'g4', 'g5', 'g6'
    ];
    // Struktur (vorher)
    /*private vergleiche: string[] = [
        'zeit', 'sued30', 'ost30', 'west30', 'ost_west30', 'g0', 'g1', 'g2', 'g3', 'g4', 'g5', 'g6', 'sued15', 'sued45', 'ost15', 'ost45',
        , 'west15', 'west45', 'ost_west15', 'ost_west45'
    ];*/

    public getData(): any[] {
        return [
            ...this.dataInsert,
            ...this.dataUpdate,
            ...this.dataUptodate
        ];
    }

    public getDataInsert(): any[] {
        return this.dataInsert;
    }

    public getDataUpdate(): any[] {
        return this.dataUpdate;
    }

    public getDataUptodate(): any[] {
        return this.dataUptodate;
    }

    public getTidByZeit(timestamp: number): number {
        const tids: number[] = timestamp
            ? this.data
                .filter((element: any) => (element.zeit || null) === timestamp)
                .map((item: any) => (item.tid || 0))
            : [];

        return tids.length ? tids[0] : 0;
    }

    private getSheetData(data: any, startRow: number): void {
        const excel = new ExcelTool();
        const workbook = excel.getWorkbook(data);
        const sheets = workbook.SheetNames || [];
        console.log('Sheets:', sheets);
        if (!sheets || !sheets.length) {
            return;
        }
        // Struktur (vorher)
        // const dataSheet: any[] = excel.getJSON(workbook, sheets[3]);
        // if (dataSheet.length && dataSheet[0].length !== 23) {
        const dataSheet: any[] = excel.getJSON(workbook, sheets[0]);

        if (dataSheet.length && dataSheet[0].length !== 26) {
            console.log('Wrong sheet?:', dataSheet[0]);
            return;
        }

        dataSheet.forEach((row: string[], index: number) => {
            if (index < startRow) {
                return;
            }
            const [
                zeit,
                sued0, sued15, sued30, sued45, sued90,
                ost0, ost15, ost30, ost45, ost90,
                west0, west15, west30, west45, west90,
                ost_west15, ost_west30, ost_west45,
                g0, g1, g2, g3, g4, g5, g6
            ] = row;
            // Struktur (vorher)
            /*const [
                zeit,
                sued30,
                sued15,
                sued45,
                ost30,
                ost15,
                ost45,
                west30,
                west15,
                west45,
                ost_west30,
                ost_west15,
                ost_west45,
                , , , , ,
                g0,
                g1,
                g2,
                g3,
                g4,
                g5,
                g6
            ] = row;*/
            const date = new Date(Math.round((+zeit - 25569) * 864e5));
            date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
            const timestamp: number = Math.round(date.valueOf() / 1000);

            if (!timestamp) {
                return;
            }
            const tid: number = this.getTidByZeit(timestamp);
            const dataImport: any = {
                tid: tid,
                zeit: timestamp,
                sued0: sued0 || 0, sued15: sued15 || 0, sued30: sued30 || 0, sued45: sued45 || 0, sued90: sued90 || 0,
                ost0: ost0 || 0, ost15: ost15 || 0, ost30: ost30 || 0, ost45: ost45 || 0, ost90: ost90 || 0,
                west0: west0 || 0, west15: west15 || 0, west30: west30 || 0, west45: west45 || 0, west90: west90 || 0,
                ost_west15: ost_west15 || 0, ost_west30: ost_west30 || 0, ost_west45: ost_west45 || 0,
                g0: g0 || 0, g1: g1 || 0, g2: g2 || 0, g3: g3 || 0, g4: g4 || 0, g5: g5 || 0, g6: g6 || 0
            };
            // Struktur (vorher)
            /*const dataImport: any = {
                tid: tid,
                zeit: timestamp,
                sued30: sued30 || 0,
                sued15: sued15 || 0,
                sued45: sued45 || 0,
                ost30: ost30 || 0,
                ost15: ost15 || 0,
                ost45: ost45 || 0,
                west30: west30 || 0,
                west15: west15 || 0,
                west45: west45 || 0,
                ost_west30: ost_west30 || 0,
                ost_west15: ost_west15 || 0,
                ost_west45: ost_west45 || 0,
                g0: g0 || 0,
                g1: g1 || 0,
                g2: g2 || 0,
                g3: g3 || 0,
                g4: g4 || 0,
                g5: g5 || 0,
                g6: g6 || 0
            };*/
            const status: string = this.getStatus(dataImport);

            switch (status) {
                case 'insert':
                    this.dataInsert.push(dataImport);
                    break;
                case 'update':
                    this.dataUpdate.push(dataImport);
                    break;
                case 'uptodate':
                    this.dataUptodate.push(dataImport);
                    break;
            }
        });
    }

    private getStatus(data: any): string {
        return (data.tid || null)
            ? (this.isDifferent(data) ? 'update' : 'uptodate')
            : 'insert';
    }

    private isDifferent(data: any): boolean {
        const vergleich = (this.data || {})
            .filter((element: any) => (element.tid || null) === (data.tid || null));
        let different = false;

        for (let i = 0, anzahl: number = (this.vergleiche || []).length; i < anzahl; ++i) {
            const key: string = this.vergleiche[i] || null;

            if (vergleich.length && ((data[key] || '') !== (vergleich[0][key] || ''))) {
                different = true;
                break;
            }
        }
        return different;
    }
}
